import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import styles from "./index.module.css";

import MyDataTable from "components/DataTable";
import PageTitle from "components/PageTitle";

import * as ajax from "helpers/ajax";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";

import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import ProgressBar from "@ramonak/react-progress-bar";
import { toPercentage, calculateSALSimple } from "helpers/functions.js"
import { toPrice, calculateImportoContrattuale,isAccordoQuadro } from "helpers/functions.js"
import SALCommessa from "./sal.js"



export default class SALCommessaQuadro extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
            salList: [[]],
            load: 0,
            openSAL: false,
            salSelected:null,

            search:"",
        };

    }

    componentDidMount = () => {
        this.load();
    }

    load = () => {
        this.state.data.incarichi.map((el,index) => {
            let url = "sal-commessas?filters[commessa][id][$eq]=" + el.id + "&sort=id";
            ajax.ajaxGetStrapi(url, (response) => {
                this.loadCallback(response,index)
            })
        })


    }

    loadCallback = (response, index) => {
        let temp = this.state.data.incarichi;
        temp[index].sal = response.data;
        this.setState({ salList: temp, load:this.state.load+1 })
    }

    calculateSALWithoutModifyingIncidenza = (data) => {
        let totalWeightedPercentage = 0;
        let totalIncidenza = 0;

        data.forEach((el) => {
            const incidenza = el.incidenza || 0;
            const elPercentage = el.percentage || 0;
            totalWeightedPercentage += (incidenza * elPercentage);
            totalIncidenza += incidenza;
        })

        return totalIncidenza > 0 ? totalWeightedPercentage / totalIncidenza : 0;
    }

    setComplete = (val, id, key, index) => {

        if (key == "incidenza") {
            if (val >= 100) { val = 100; }
            if (val < 0 || !val) { val = null }
            let temp = this.state.salList;
            temp[index].incidenza = val;

            temp = this.state.data;
            temp.incarichi[index].incidenza = val;
        }

        let data = {}
        data[key] = val;

        let formData = { "data": data };
        ajax.ajaxPutStrapi("commessas/" + id, formData, this.load)        
    }

    calculateSalQuadro = () => {
        let totalIncidenza = 0;
        let totalWeightedPercentage = 0;

        // First calculate total incidenza
        this.state.salList.forEach((el) => {
            if (!el.sal) { el.sal = [] }
            if (!el.incidenza) { el.incidenza = 0 }
            totalIncidenza += parseFloat(el.incidenza) || 0;
        });

        // Calculate weighted average with normalization
        this.state.salList.forEach((el) => {
            const incidenza = parseFloat(el.incidenza) || 0;
            const salPercentage = calculateSALSimple(el.sal);
            
            // Normalize incidenza to percentage of total
            const normalizedIncidenza = totalIncidenza > 0 ? (incidenza / totalIncidenza) * 100 : 0;
            
            totalWeightedPercentage += (salPercentage * normalizedIncidenza / 100);
        });

        return totalWeightedPercentage;
    }
    

    renderSAL = (el, index) => {
        if (!el.id) {return}
        if (this.state.load < this.state.data.incarichi.lenth) { return null }
        //search filter
        if (!(el.nome.toUpperCase() + " " + el.codice_identificativo.toUpperCase()).includes(this.state.search.toUpperCase())) { return null }
        if (!el.sal) { el.sal = []; }

        let importoContrattuale = calculateImportoContrattuale(el, false)
        let importoFatturato = 0;

        let sal = calculateSALSimple(el.sal);

        el.fattures.map((fatt) => {
            importoFatturato += (fatt.imponibile * (1 + (fatt.iva / 100)))
        })




        return (
            <Grid container alignItems="center" key={"sal-" + index}  sx={{ borderBottom: "1px solid #00000080", marginBottom: "10px", paddingBottom: "10px" }}>
                {/* <Grid item style={{ flex: 1 }}>
                    <FormControlLabel
                        control={<Switch checked={el.completed} onChange={(e) => this.setComplete(e.target.checked, el.id)} />}
                        label={<MDTypography variant="button" sx={{ textDecoration: (el.completed)?'line-through':'none' }}>{el.nome}</MDTypography>}
                        style={{ width: "100%" }}
                    />
                </Grid>
                */}

                <Grid item sm={2} >
                    <MDTypography variant="button" sx={{ textDecoration: (el.completed) ? 'line-through' : 'none' }}>{el.codice_identificativo}</MDTypography>
                </Grid>

                <Grid item sm={2} >
                    <MDTypography variant="button" sx={{ textDecoration: (el.completed) ? 'line-through' : 'none' }}>{el.nome}</MDTypography>
                </Grid>

                <Grid item sm={1} mr={1}>
                    <MDInput variant="outlined" key={new Date()+index} type={"number"} defaultValue={el.incidenza} onBlur={(e) => this.setComplete(e.target.value, el.id, "incidenza", index)}  />
                </Grid>


                <Grid item sm={2} pr={2} pl={2}>
                    {this.renderProgressBar(calculateSALSimple(el.sal))}
                </Grid>

                <Grid item sm={1} mr={1} style={{ textAlign: "center" }}>
                    <MDTypography variant="caption" sx={{ textDecoration: (el.completed) ? 'line-through' : 'none' }}>{toPrice(importoContrattuale)}</MDTypography>
                </Grid>
                <Grid item sm={1} mr={1} style={{textAlign:"center"}}>
                    <MDTypography variant="caption" sx={{ textDecoration: (el.completed) ? 'line-through' : 'none' }}>{toPrice(importoContrattuale * sal / 100)}</MDTypography>
                </Grid>
                <Grid item sm={1} mr={1} style={{ textAlign: "center" }}>
                    <MDTypography variant="caption" sx={{ textDecoration: (el.completed) ? 'line-through' : 'none' }}>{toPrice(importoFatturato)}</MDTypography>
                </Grid>
                <Grid item sm={1} mr={1} style={{ textAlign: "center" }}>
                    <MDTypography variant="caption" sx={{ textDecoration: (el.completed) ? 'line-through' : 'none' }}>{toPrice(importoContrattuale - importoFatturato)}</MDTypography>
                </Grid>

                <Grid item mr={1}>
                    <MDButton variant="gradient" color="success" iconOnly onClick={() => this.setState({ openSAL:true, salSelected:el })}>
                        <Icon>visibility</Icon>
                    </MDButton>
                </Grid>
            </Grid>
        )
    }

    renderProgressBar = (percentage) => {
        return (
            <ProgressBar className={styles.progressBar} completed={percentage} customLabel={toPercentage(percentage)} />
            )
    }

    render() {

        if (this.state.openSAL) {
             return <SALCommessa data={this.state.salSelected} backFunction={() => { this.setState({ openSAL: false }); this.load() }} />
        }

        return (
            <DashboardLayout>
                <DashboardNavbar />
                <PageTitle
                    text={"SAL- " + this.state.data.nome}
                    backButton={this.props.backFunction}
                />

                <Grid container mt={3}>
                    <Grid item sm={6}>
                        <MDTypography variant="h3" textTransform="uppercase">{this.state.data.nome}</MDTypography>
                    </Grid>
                    <Grid item sm={4} pl={2} pr={2} >
                        <MDTypography variant="label">Avanzamento Globale</MDTypography>
                        {this.renderProgressBar(this.calculateSalQuadro())}
                    </Grid>
                    <Grid item sm={2} pl={2} pr={2} >
                        <MDInput variant="outlined" key={"search"} placeholder={"Cerca"} onChange={(e) => { this.setState({ search: e.target.value})}} defaultValue={""} />
                    </Grid>

                </Grid>

                <Grid mt={5}>
                    <Grid container>
                        <Grid item sm={2} >
                            <MDTypography variant="button">Codice Identificativo </MDTypography>
                        </Grid>
                        <Grid item sm={2} >
                            <MDTypography variant="button">Incarico</MDTypography>
                        </Grid>

                        <Grid item sm={1} mr={1}>
                            <MDTypography variant="button">Incidenza</MDTypography>
                        </Grid>
                        <Grid item sm={1}>
                            <MDTypography variant="button"></MDTypography>
                        </Grid>
                        <Grid item sm={1}>
                            <MDTypography variant="button"></MDTypography>
                        </Grid>
                        <Grid item sm={1} mr={1} >
                            <MDTypography variant="button" style={{display:"flex",textAlign:"center"}}>Importo contrattuale</MDTypography>
                        </Grid>
                        <Grid item sm={1} mr={1}>
                            <MDTypography variant="button" style={{ display: "flex", textAlign: "center" }}>Importo avanzamento</MDTypography>
                        </Grid>
                        <Grid item sm={1} mr={1} style={{display:"flex"}}>
                            <MDTypography variant="button" style={{ width:"100%",textAlign: "center" }}>Importo <br/> fatturato</MDTypography>
                        </Grid>
                        <Grid item sm={1} mr={1}>
                            <MDTypography variant="button" style={{ display: "flex", textAlign: "center" }}>Rimanenza da fatturare</MDTypography>
                        </Grid>

                    </Grid>

                    {this.state.salList.map((sal,index) => {
                        return this.renderSAL(sal, index);
                    })}
                </Grid>
            </DashboardLayout>
        )
    }
}


